<template src="./single-invoice.html">
</template>
<script>
  import Vue from 'vue'
  import Autocomplete from '@/components/misc/autocomplete/Autocomplete'
  import { EventBus } from '@/router/bus'
  import i18n from '@/i18n'
  import { hasInvoiceCancelClaim, hasInvoiceExportClaim, hasInvoiceAssignClaim, hasInvoiceUserSettlementClaim, hasInvoiceActivateClaim, hasInvoiceActivateOnceClaim, getOrganizationId, hasAdminClaim } from '@/router/auth'
  import Loader from '@/components/misc/Loader'
  import ContextHeader from '@/components/misc/context-header/ContextHeader'
  import { Money } from 'v-money'
  import { validationMixin } from '@/mixins/validation'
  import { required, requiredIf } from 'vuelidate/lib/validators'
  import Datepicker from '@/utils/datepicker/'
  import { srCYRL, sr, en } from '@/utils/datepicker/locale'
  import Moment from 'moment'

  export default {
    name: 'single-invoice',
    mixins: [validationMixin],
    components: {
      Loader,
      Autocomplete,
      ContextHeader,
      Money,
      Datepicker
    },
    data () {
      return {
        load: false,
        dateFormat: this.$store.getters.dateFormat,
        dateLocale: srCYRL,
        IssueCategory: [
          { DESCRIPTION: 'InvoiceLiability', ID: 1 },
          { DESCRIPTION: 'InvoiceSettlement', ID: 2 }
        ],
        IssueCategories: {
          VALIDITY: 'Validity'
        },
        DeltaStatus: {
          ACTIVE: 1,
          CANCELLED: 2,
          ACTIVATION: 3
        },
        InvoiceStatus: {
          ACTIVE: 1,
          INVALID: 2,
          CANCELLED: 3,
          PARTIALLY_SETTLED: 4,
          SETTLED: 5,
          ASSIGNED: 6,
          PROINVOICE: 7
        },
        SettlementStatus: {
          ACTIVE: 1,
          CANCELLED: 2
        },
        IssueCategoryVisibility: {
          EVERYONE: 1,
          CREDITOR: 2,
          DEBTOR: 3
        },
        currency: {
          decimal: this.$store.getters.decimalFormat,
          thousands: this.$store.getters.decimalFormat === ',' ? '.' : ',',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        invoiceId: this.$route.params.invoiceId,
        invoice: {},
        invoiceDelta: {},
        settlementUrl: '',
        fields: [
          {
            key: 'id',
            label: i18n.t('invoices.columnId')
          },
          {
            key: 'settledAmount',
            label: i18n.t('invoices.columnSettledAmount')
          },
          {
            key: 'settlementDate',
            label: i18n.t('invoices.columnSettlementDate')
          },
          {
            key: 'settlementComments',
            label: i18n.t('invoices.columnSettlementComments')
          },
          {
            key: 'settlementStatus',
            label: i18n.t('invoices.columnSettlementStatus')
          },
          {
            key: 'cancelSettlement',
            label: ' '
          }
        ],
        settlements: [],
        deltaFields: [
          {
            key: 'amount',
            label: i18n.t('invoices.invoiceDeltaColumnAmount')
          },
          {
            key: 'creationDate',
            label: i18n.t('invoices.invoiceDeltaColumnDate')
          },
          {
            key: 'comments',
            label: i18n.t('invoices.invoiceDeltaColumnComments')
          },
          {
            key: 'previousDueDate',
            label: i18n.t('invoices.columnPreviousDueDate')
          },
          {
            key: 'cancelSlot',
            label: ' '
          }
        ],
        invoiceDeltas: [],
        invoiceSettlementIDs: [],
        hasInvoiceCancelClaim: false,
        hasInvoiceExportClaim: false,
        hasInvoiceAssignClaim: false,
        hasInvoiceActivateClaim: false,
        hasInvoiceActivateOnceClaim: false,
        hasInvoiceUserSettlementClaim: false,
        hasAdminClaim: false,
        autoCompleteUrl_budgetId: Vue.$apiConfig.budgetRegistryGet,
        invoiceLink: '',
        assignationLink: '',
        settlementDeltaSelected: false,
        selectedAmountDeltaId: 0,
        selectedAmountDeltaAmount: 0,
        assignedDebtorCompanyNumber: null,
        assignedDebtorName: null,
        assignedDebtorTaxIdNumber: null,
        debtorLink: '',
        creditorLink: '',
        organizationId: 0,
        currentIssue: null,
        currentIssueCategories: null,
        formattedIssueCategories: null,
        currentIssueCategory: null,
        selectedCategory: null,
        currentIssueReport: {},
        currentIssueAmount: 0,
        currentIssueSettlementId: null,
        invoiceFields: Vue.$config.invoice_fields,
        activeIssues: [],
        reportedIssues: 0,
        reportedActiveIssues: 0,
        showCollapse: {
          invoice_settlements: false,
          invoice_assignment: false,
          amount_change: false
        },
        Sinks: {
          Email: 1
        },
        NotificationTypes: {
          IssueProcessed: 5
        },
        invoiceSettlement: {
          settlementId: null,
          cancelComments: null,
          IsCompensationSettlement: false
        }
      }
    },
    computed: {
      invoiceActive () {
        return this.invoice.status === this.InvoiceStatus.ACTIVE
      },
      invoiceProinvoice () {
        return this.invoice.status === this.InvoiceStatus.PROINVOICE
      },
      invoiceCancelled () {
        return this.invoice.status === this.InvoiceStatus.CANCELLED
      },
      invoiceInvalid () {
        return this.invoice.status === this.InvoiceStatus.INVALID
      },
      invoiceSettled () {
        return this.invoice.status === this.InvoiceStatus.SETTLED
      },
      invoicePartiallySettled () {
        return this.invoice.status === this.InvoiceStatus.PARTIALLY_SETTLED
      },
      invoiceAssignedFrom () {
        return this.invoice.assignedInvoiceId && this.invoice.assignedInvoiceId.length > 0
      },
      invoiceAssignedTo () {
        return this.invoice.status === this.InvoiceStatus.ASSIGNED
      },
      invoiceReportedInvalid () {
        return this.activeIssues.filter(ai => ai.category === this.IssueCategories.VALIDITY).length !== 0
      },
      exportDisabled () {
        return !this.hasInvoiceExportClaim || this.load
      },
      cancelDisabled () {
        return !this.hasInvoiceCancelClaim ||     // User doesn't have cancel claim
          this.invoiceSettled ||                  // Invoice is settled
          this.invoicePartiallySettled ||         // Invoice is partially settled
          this.load                               // Loading state
      },
      canCancelInvoice () {
        return (this.invoice.creditorId === this.organizationId) && !this.invoiceCancelled && !this.invoiceInvalid
      },
      canAssignInvoice () {
        return this.hasInvoiceAssignClaim &&      // User has assignation claim
          !this.invoiceAssignedTo &&              // Invoice is not already assigned to
          !this.invoiceAssignedFrom &&            // Invoice is not already assigned from
          !this.invoiceCancelled &&               // Invoice is not cancelled
          !this.invoiceInvalid &&               // Invoice is not invalid
          !this.invoicePartiallySettled &&        // Invoice is not partially settled
          !this.invoiceSettled                    // Invoice is not settled
      },
      canViewAssignement () {
        return this.invoiceAssignedFrom || this.invoiceAssignedTo
      },
      assignDisabled () {
        return this.invoiceCancelled ||                                               // Invoice is cancelled
          !this.invoice.debtorId || this.invoice.debtorId !== this.organizationId ||  // User is not direct debtor
          !this.hasInvoiceAssignClaim ||                                              // User doesn't have assignation claim
          this.load                                                                   // Loading state
      },
      isPublicEntity () {
        return this.assignedDebtorCompanyNumber && this.assignedDebtorCompanyNumber.length === 5
      },
      isPrivateEntity () {
        return this.assignedDebtorCompanyNumber && this.assignedDebtorCompanyNumber.length === 8
      },
      canActivateInvoice () {
        return this.hasInvoiceActivateClaim || this.hasInvoiceActivateOnceClaim
      },
      canSettleInvoice () {
        return !this.invoiceSettled && this.hasInvoiceUserSettlementClaim && (this.invoice.debtorId === this.organizationId)
      },
      canCancelSettlement () {
        return this.hasInvoiceUserSettlementClaim && (this.invoice.debtorId === this.organizationId)
      },
      isCurrentUserAdmin () {
        return this.hasAdminClaim
      },
      isCurrentUserDebtor () {
        return this.invoice.debtorId && (this.invoice.debtorId === this.organizationId)
      },
      isCurrentUserCreditor () {
        return this.invoice.creditorId && (this.invoice.creditorId === this.organizationId)
      },
      hasInvoiceSettlements () {
        return this.settlements && this.settlements.length > 0
      },
      canReportIssue () {
        return this.isCurrentUserCreditor || this.isCurrentUserDebtor
      },
      lastActiveSettlement () {
        let activeSettlements = this.settlements.filter((settlement) => {
          return settlement.status === this.SettlementStatus.ACTIVE
        })
        if (activeSettlements.length === 0) {
          return null
        }
        let retVal = activeSettlements[0].settlementDate

        activeSettlements.forEach((settlement) => {
          if (new Date(settlement.settlementDate) > new Date(retVal)) {
            retVal = settlement.settlementDate
          }
        })
        return retVal
      },
      collapseAllDisabled () {
        return !Object.values(this.showCollapse).includes(true)
      },
      expandAllDisabled () {
        return !Object.values(this.showCollapse).includes(false)
      }
    },
    mounted: function () {
      switch (this.$store.getters.dateLocale) {
        case 'sr-cyrl':
          this.dateLocale = srCYRL
          break
        case 'sr':
          this.dateLocale = sr
          break
        case 'en':
          this.dateLocale = en
          break
        default:
          this.dateLocale = srCYRL
      }
    },
    created: function () {
      this.hasInvoiceCancelClaim = hasInvoiceCancelClaim()
      this.hasInvoiceExportClaim = hasInvoiceExportClaim()
      this.hasInvoiceAssignClaim = hasInvoiceAssignClaim()
      this.hasInvoiceActivateClaim = hasInvoiceActivateClaim()
      this.hasInvoiceActivateOnceClaim = hasInvoiceActivateOnceClaim()
      this.hasInvoiceUserSettlementClaim = hasInvoiceUserSettlementClaim()
      this.organizationId = parseInt(getOrganizationId())
      this.hasAdminClaim = hasAdminClaim()
      this.loadInvoice()
    },
    methods: {
      invoiceEmpty () {
        return Object.keys(this.invoice).length === 0 && this.invoice.constructor === Object
      },
      loadInvoice () {
        this.load = true
        this.$http.get(Vue.$apiConfig.invoice + '/' + this.invoiceId)
          .then(response => {
            this.load = false
            this.logConsole(response)
            let invoiceResponse = response.data.payload
            this.invoice = invoiceResponse.liability
            this.settlements = invoiceResponse.settlements
            this.invoiceDeltas = invoiceResponse.liabilityDeltas
            this.assignedDebtorCompanyNumber = invoiceResponse.assignedDebtorCompanyNumber
            this.assignedDebtorTaxIdNumber = invoiceResponse.assignedDebtorTaxIdNumber
            this.assignedDebtorName = invoiceResponse.assignedDebtorName
            this.reportedIssues = invoiceResponse.issues.length
            for (let i = 0; i < invoiceResponse.issues.length; i++) {
              if (invoiceResponse.issues[i].status === 1) {
                this.reportedActiveIssues++
                this.activeIssues.push(invoiceResponse.issues[i])
              }
            }

            for (let i = 0; i < this.settlements.length; i++) { this.invoiceSettlementIDs.push(this.settlements[i].id) }

            this.invoiceLink = '/invoices/' + this.invoice.assignedInvoiceId
            this.assignationLink = '/invoices/' + this.invoice.comments

            this.debtorLink = '/user-registration/approval/' + this.invoice.debtorId
            this.creditorLink = '/user-registration/approval/' + this.invoice.creditorId

            if (!!Vue.$config.invoices && !!Vue.$config.invoices.show_collapse) {
              Object.keys(Vue.$config.invoices.show_collapse).forEach((key) => {
                if (this.showCollapse.hasOwnProperty(key)) {
                  Vue.set(this.showCollapse, key, Vue.$config.invoices.show_collapse[key].value)
                  if (Vue.$config.invoices.show_collapse[key].collapse_if_faulty) {
                    if (Array.isArray(this[Vue.$config.invoices.show_collapse[key].collapse_if_faulty])) {
                      if (!this[Vue.$config.invoices.show_collapse[key].collapse_if_faulty].length) {
                        Vue.set(this.showCollapse, key, false)
                      }
                    } else if (this[Vue.$config.invoices.show_collapse[key].collapse_if_faulty] === false) {
                      Vue.set(this.showCollapse, key, false)
                    }
                  }
                }
              })
            }
          }, error => {
            this.logConsole(error)

            EventBus.$emit('alert', {
              variant: 'danger',
              message: this.$t('invoices.invoiceNotFound') + ' : ' + this.invoiceId,
              errors: []
            })

            this.load = false
          })
      },
      validateBeforeSettle () {
        this.invoiceSettlement.InvoiceId = this.invoice.invoiceId
        this.$v.$touch()
        if (this.$v.$invalid) {
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('errors.someErrorsOccuredCheckListBelow'),
            errors: this.getValidationErrors('invoiceSettlement')
          })
          return
        }
        this.settleInvoice()
      },
      settleInvoice () {
        this.load = true
        this.$refs['settleInvoiceModal'].hide()
        this.$http.post(Vue.$apiConfig.registerUserSettlementPost, [this.invoiceSettlement])
          .then(response => {
            this.logConsole(response)
            this.load = false
            let responseData = response.data.payload[0]
            let invoice = responseData.settlement
            let error = responseData.settlementError
            this.load = false
            if (error === null) {
              EventBus.$emit('alert', {
                variant: 'success',
                message: this.$t('invoices.registerSettlementSuccess') + ' - ',
                link: '/invoices/' + invoice.invoiceId,
                linkDescription: invoice.invoiceId,
                errors: []
              })
              this.invoiceSettlement.SettledAmount = 0
              this.invoiceSettlement.Bank = null
              this.invoiceSettlement.ReferenceNumber = null
              this.invoiceSettlement.DebitAccount = null
              this.invoiceSettlement.CreditAccount = null
              this.invoiceSettlement.SettlementDate = null
              this.invoiceSettlement.IsCompensationSettlement = false
              this.$v.$reset()
              this.loadInvoice()
            } else {
              EventBus.$emit('alert', {
                variant: 'danger',
                message: this.$t('apiStatusCodes.' + error.code),
                errors: []
              })
            }
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      validateBeforeCancel (settlementId) {
        this.invoiceSettlement.settlementId = settlementId.toString()
        this.$refs['cancelSettlementModal'].show()
      },
      cancelSettlement () {
        this.logConsole('Cancelling settlement')
        this.load = true
        this.$http.post(Vue.$apiConfig.cancelUserSettlementPost, this.invoiceSettlement)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('invoices.cancelSettlementSuccess'),
              errors: []
            })
            this.invoiceSettlement.settlementId = null
            this.invoiceSettlement.cancelComments = null
            this.loadInvoice()
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
        this.$refs['cancelSettlementModal'].hide()
      },
      cancelInvoice: function (e) {
        this.logConsole('Cancelling invoice')
        this.load = true
        let cancelInvoice = [
          { InvoiceId: this.invoice.invoiceId, CancelComments: this.invoice.cancelComments }
        ]
        this.$http.post(Vue.$apiConfig.cancelInvoicesPost, cancelInvoice)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('invoices.cancellationSuccess'),
              errors: []
            })
            this.invoice.status = this.InvoiceStatus.CANCELLED
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      assignInvoice () {
        this.logConsole('Assigning invoice')
        this.load = true
        let invoiceAssignment = {
          InvoiceId: this.invoice.invoiceId,
          AssignmentContractNumber: this.invoice.AssignmentContractNumber,
          DebtorCompanyNumber: this.invoice.DebtorCompanyNumber,
          DebtorTaxIdNumber: this.invoice.DebtorTaxIdNumber
        }
        this.$http.post(Vue.$apiConfig.assignInvoicePost, invoiceAssignment)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('invoices.invoiceAssignSuccess'),
              errors: []
            })

            this.loadInvoice()
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      cancelInvoiceAssign () {
        this.logConsole('Assigning invoice')
        this.load = true
        let invoiceAssignment = { InvoiceId: this.invoice.invoiceId }
        this.$http.post(Vue.$apiConfig.cancelAssignInvoicePost, invoiceAssignment)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('invoices.invoiceAssignCancelSuccess'),
              errors: []
            })
            this.invoice.status = this.InvoiceStatus.ACTIVE
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      addInvoiceAmountDelta () {
        this.load = true
        this.invoiceDelta.invoiceId = this.invoice.invoiceId
        this.$http.post(Vue.$apiConfig.changeInvoiceAmountPost, this.invoiceDelta)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('invoices.invoiceAmountChangeSuccess'),
              errors: []
            })

            setTimeout(() => {
              this.loadInvoice()
            }, 300)
            this.invoice.amount += this.invoiceDelta.amount
            this.invoiceDelta.comments = ''
            this.invoiceDelta.amount = 0
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      cancelInvoiceDeltaSelected (id, amount) {
        this.selectedAmountDeltaId = id
        this.selectedAmountDeltaAmount = amount
        this.$refs.cancelInvoiceDeltaModal.show()
      },
      cancelInvoiceAmountDelta () {
        this.load = true
        this.invoiceDelta.id = this.selectedAmountDeltaId
        this.$http.post(Vue.$apiConfig.cancelInvoiceAmountChangePost, this.invoiceDelta)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('invoices.invoiceAmountChangeSuccess'),
              errors: []
            })

            setTimeout(() => {
              this.loadInvoice()
            }, 300)
            this.invoice.amount -= this.selectedAmountDeltaAmount
            this.invoiceDelta.cancelComments = ''
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      getInvoiceAmountDeltas () {
        this.load = true
        this.$http.get(Vue.$apiConfig.invoiceAmountChangesGet + '/' + this.invoiceId)
          .then(response => {
            this.logConsole(response)
            this.load = false
            let invoiceResponse = response.data.payload
            this.invoiceDeltas = invoiceResponse
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      exportToCsv: function () {
        this.logConsole('Exporting invoice to CSV ')
        this.load = true
        let request = []
        request.push(this.invoice.invoiceId)
        this.saveToFile(Vue.$config.reporting_api_root + '/' + Vue.$apiConfig.exportInvoiceCsv, request, 'export.csv', this.stopLoader, this.convertCSVseparator)
      },
      exportToJson: function () {
        this.logConsole('Exporting invoice to JSON')
        this.load = true
        let request = []
        request.push(this.invoice.invoiceId)
        this.saveToFile(Vue.$config.reporting_api_root + '/' + Vue.$apiConfig.exportInvoiceJson, request, 'export.json', this.stopLoader)
      },
      stopLoader () {
        this.load = false
      },
      calculateSettlementsDelta () {
        if (!this.browserFirefox()) {
          if (this.settlementDeltaSelected) {
            this.invoiceDelta.amount = this.invoice.settledAmount - this.invoice.amount
          } else {
            this.invoiceDelta.amount = 0
          }
        }
      },
      calculateSettlementsDeltaChange () {
        if (this.browserFirefox()) {
          if (this.settlementDeltaSelected) {
            this.invoiceDelta.amount = this.invoice.settledAmount - this.invoice.amount
          } else {
            this.invoiceDelta.amount = 0
          }
        }
      },
      reportLiabilityIssue () {
        this.load = true
        this.$http.get(Vue.$apiConfig.issueCategoriesGet + '/' + this.IssueCategory[0].DESCRIPTION)
          .then(response => {
            this.logConsole(response)
            this.selectedCategory = null
            this.currentIssueCategory = null
            this.formattedIssueCategories = null
            this.currentIssueReport = {}
            this.currentIssue = this.IssueCategory[0]
            this.currentIssueCategories = response.data.payload
            this.currentIssueReport.resourceId = this.invoice.invoiceId
            this.formatReportCategories(response.data.payload)

            this.$refs.reportIssueModal.show()
            this.load = false
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      reportSettlementIssue () {
        this.load = true
        this.$http.get(Vue.$apiConfig.issueCategoriesGet + '/' + this.IssueCategory[1].DESCRIPTION)
          .then(response => {
            this.logConsole(response)
            this.selectedCategory = null
            this.currentIssueCategory = null
            this.formattedIssueCategories = null
            this.currentIssueSettlementId = null
            this.currentIssueReport = {}
            this.currentIssue = this.IssueCategory[1]
            this.currentIssueCategories = response.data.payload
            this.currentIssueReport.resourceId = this.invoice.invoiceId
            this.formatReportCategories(response.data.payload)
            if (this.formattedIssueCategories && this.formattedIssueCategories.length > 0) {
              this.$refs.reportIssueModal.show()
            }
            this.load = false
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      formatReportCategories (categories) {
        this.formattedIssueCategories = []
        for (let i = 0; i < categories.length; i++) {
          if (categories[i].id === 3) {
            if (this.invoiceSettled) { continue }
          }
          if (categories[i].id === 4) {
            if (!this.hasInvoiceSettlements) { continue }
          }
          if (categories[i].id === 5) {
            if (!this.hasInvoiceSettlements) { continue }

            let jpSettlement = false
            for (let i = 0; i < this.settlements.length; i++) {
              if (this.settlements[i].settlementComments && this.settlements[i].settlementComments.startsWith('JP#')) {
                jpSettlement = true
              }
            }

            if (!jpSettlement) { continue }
          }
          let category = {
            text: categories[i].categoryCyr,
            value: categories[i].id
          }
          if ((categories[i].categoryVisibility === this.IssueCategoryVisibility.CREDITOR && this.isCurrentUserCreditor) ||
          (categories[i].categoryVisibility === this.IssueCategoryVisibility.DEBTOR && this.isCurrentUserDebtor) ||
          (categories[i].categoryVisibility === this.IssueCategoryVisibility.EVERYONE)) {
            this.formattedIssueCategories.push(category)
          }
        }
      },
      categoryChanged () {
        for (let i = 0; i < this.currentIssueCategories.length; i++) {
          if (this.currentIssueCategories[i].id === this.selectedCategory) {
            this.currentIssueCategory = this.currentIssueCategories[i]
            return
          }
        }
      },
      submitIssueReport () {
        this.currentIssueReport.resource = this.currentIssue.ID

        if (this.currentIssueCategory) {
          this.currentIssueReport.category = this.currentIssueCategory.category
          this.currentIssueReport.requiresData = this.currentIssueCategory.requiresData
          this.currentIssueReport.categoryId = this.currentIssueCategory.id
        }

        if (this.currentIssue.ID === this.IssueCategory[1].ID) {
          if (this.currentIssueCategory && this.currentIssueCategory.id === 3) {
            if (this.currentIssueReport.data && this.currentIssueReport.data) {
              this.currentIssueReport.data = this.currentIssueAmount + ' ' + this.currentIssueReport.data
            }
          } else if (this.currentIssueCategory && this.currentIssueCategory.id === 4) {
            if (this.currentIssueSettlementId && this.currentIssueReport.data && this.currentIssueReport.data) {
              this.currentIssueReport.data = this.currentIssueSettlementId + ' ' + this.currentIssueAmount + ' ' + this.currentIssueReport.data
            }
          }
        }

        if (this.currentIssue.ID === this.IssueCategory[0].ID) {
          if (this.currentIssueCategory && this.currentIssueCategory.id === 2) {
            this.currentIssueReport.affectedOrganizationId = this.invoice.creditorId
          }
        }

        let report = []
        report.push(this.currentIssueReport)

        this.load = true
        this.$http.post(Vue.$apiConfig.issueRegisterPost, report)
          .then(response => {
            this.logConsole(response)
            this.load = false

            let reportedIssue = response.data.payload[0]
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('issues.reportIssueSuccess') + ' - ',
              link: '/reported-issues/' + reportedIssue.id,
              linkDescription: reportedIssue.id,
              errors: []
            })
            this.subscribeToIssueProcessedNotifications(reportedIssue.id)
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      subscribeToIssueProcessedNotifications (issueId) {
        this.subscribeToIssueProcessedNotificationType(issueId)
      },
      subscribeToEmailSink () {
        this.$http.post(Vue.$config.notification_api_root + '/' + Vue.$apiConfig.sinksSubscribe, {sinks: [this.Sinks.Email]})
          .then(response => {
            this.logConsole(response)
          }, error => {
            this.logConsole(error)
          })
      },
      subscribeToIssueProcessedNotificationType (issueId) {
        this.$http.post(Vue.$config.notification_api_root + '/' + Vue.$apiConfig.notificationSubcribe, {notificationTypes: [this.NotificationTypes.IssueProcessed], resourceId: issueId, resourceType: Vue.$config.issueResourceType})
          .then(response => {
            this.logConsole(response)
            this.subscribeToEmailSink()
          }, error => {
            this.logConsole(error)
          })
      },
      customFormatter (date) {
        Moment.locale(this.$store.getters.dateLocale)
        return Moment(date).format(this.dateFormat)
      },
      inputFormat (date) {
        Moment.locale(this.$store.getters.dateLocale)
        return Moment(date, this.dateFormat).valueOf()
      }
    },
    validations: {
      invoiceSettlement: {
        ReferenceNumber: {
          required
        },
        CreditAccount: {
          required: requiredIf((invoiceSettlement) => {
            return !invoiceSettlement.IsCompensationSettlement
          })
        },
        DebitAccount: {
          required: requiredIf((invoiceSettlement) => {
            return !invoiceSettlement.IsCompensationSettlement
          })
        },
        SettledAmount: {
          required
        },
        SettlementDate: {
        },
        Bank: {
          required: requiredIf((invoiceSettlement) => {
            return !invoiceSettlement.IsCompensationSettlement
          })
        }
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>

  @import '~@/assets/scss/variables.scss';

  .bg-primary {
    background-color: $primary-color-accent !important;
  }

  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }

  #cancelInvoiceModal {
    margin-top: 60px;
  }

  .property-label {
    font-size: 11pt;
    font-weight: 400;
  }

  .property-label-caption {
    font-size: 12pt;
    font-weight: 600;
  }

  .full-width {
    width: 100%;
  }

  .invoice-cancelled-card {
    background-color: transparentize($background-color-danger, .9) !important;
  }

  .invoice-settled-card {
    background-color: transparentize($background-color-success, .9) !important;
  }

  .invoice-partially-settled-card {
    background-color: transparentize($background-color-info, .9) !important;
  }

  .invoice-assigned-card {
    background-color: transparentize($background-color-warning, .9) !important;
  }

  .settle-input {
    margin-right: 5px;
  }

  .field-description {
    margin-top: .25rem;
    font-size: .875rem;
    color: $background-color-danger;
  }

  .report-image {
    cursor: pointer;
     width: 36px;
     height: 36px;
  }
  .accordion-controls button {
    text-decoration: none !important;
  }
</style>



// WEBPACK FOOTER //
// SingleInvoice.vue?0314e557